var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.39156 5.92405C4.58011 6.19691 4.52375 5.96955 4.52375 11.4084C4.52375 11.8951 5.07903 12.1736 5.47039 11.8825C7.14272 10.6216 7.47685 10.5124 7.47685 9.92268C7.47685 5.95931 7.43065 6.18219 7.60904 5.92405L10.3247 2.22754H1.6759L4.39156 5.92405Z",
    fill: "#435465"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3498 0.301406C11.2528 0.115547 11.0624 0 10.8529 0H1.14615C0.693692 0 0.427466 0.510398 0.687013 0.88125C0.689146 0.884812 0.657552 0.84157 1.15858 1.52344H10.8405C11.2675 0.942352 11.5528 0.691289 11.3498 0.301406Z",
    fill: "#435465"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.e444fda0.svg";
export { ForwardRef as ReactComponent };